export class ConsumeTaxRequestModel {
  // 部門コード
  public classCode: string = <string>'';
  // 受注コード
  public orderCode: string = <string>'';
  // 小分類コード
  public smallClassCode: string = <string>'';
  // 配達企画回
  public delivCatalogID: string = <string>'';
}
